export const KEY_EVENT_OPEN_MODAL_BUY = 'eipoOpenModalBuy';
export const KEY_EVENT_CLOSE_MODAL_BUY = 'eipoCloseModalBuy';
export const KEY_EVENT_OPEN_MODAL_SUCCESS = 'eipoOpenModalSuccess';
export const KEY_EVENT_CLOSE_MODAL_SUCCESS = 'eipoCloseModalSuccess';
export const KEY_EVENT_OPEN_MODAL_DEPOSIT = 'eipoOpenModalDeposit';
export const KEY_EVENT_SHOW_TOAST_ERROR = 'eipoShowToastError';
